import React, { useState } from "react";
import "./postCardList.scss";
import PostCard from "../common/post-card/postCard";
import PropTypes from "prop-types";
import { triggerBuzzClickEvent } from "../../utils/garfieldHelpers";
import { EVENT_NAMES } from "../../constants/garfieldEvents";

const PostCardList = ({
  posts,
  showMoreVisibility,
  showMoreCount,
  cardOrientation,
  imgPosition,
  customClassName,
  imgVariant,
  sectionId,
  source,
  flow,
}) => {
  const [loadMorePost, setLoadMorePost] = useState(1);

  const showPosts = showMoreCount
    ? showMoreCount
    : posts?.length;

  const handleLoadMorePostsClick = () => {
    setLoadMorePost(loadMorePost + 1);
    triggerBuzzClickEvent(
      EVENT_NAMES.ALL_ARTICLES_LOAD_MORE_POSTS_CLICKED,
      {},
      sectionId,
      source,
      flow
    );
  };

  return (
    <>
      <div
        className={`post-card-list ${
          customClassName || ""
        } ${cardOrientation || ""}`}
      >
        {posts
          .slice(
            0,
            Math.min(showPosts * loadMorePost, posts.length)
          )
          .map(post => {
            return (
              <PostCard
                key={post.id}
                post={post}
                cardOrientation={cardOrientation}
                imgPosition={imgPosition}
                imgVariant={imgVariant}
                sectionId={sectionId}
                source={source}
                flow={flow}
              />
            );
          })}
      </div>
      {showMoreVisibility &&
        posts?.length > showPosts &&
        Math.min(showPosts * loadMorePost, posts.length) <
          posts.length && (
          <div className="load-more-button">
            <button
              type="button"
              className="load-more"
              onClick={handleLoadMorePostsClick}
            >
              Load More Posts
            </button>
          </div>
        )}
    </>
  );
};

PostCardList.propTypes = {
  posts: PropTypes.object,
  showMoreVisibility: PropTypes.bool,
  showMoreCount: PropTypes.number,
  cardOrientation: PropTypes.string,
  imgPosition: PropTypes.string,
  customClassName: PropTypes.string,
  imgVariant: PropTypes.string,
  sectionId: PropTypes.string,
  source: PropTypes.string,
  flow: PropTypes.string,
};

export default PostCardList;
